export default function Chart() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chart icon</title>
      <path
        d="M7.91619 5.77189C8.2052 5.75097 8.49422 5.92876 8.6493 6.12746L11.543 9.05575L14.1547 6.47258L12.84 5.17228C12.6321 4.96661 12.7026 4.77836 12.9951 4.75396C12.9951 4.75396 17.4079 4.32517 17.4995 4.41232C17.5876 4.49948 17.1541 8.86402 17.1541 8.86402C17.1294 9.15336 16.9391 9.22308 16.7311 9.0174L15.4165 7.7171L12.8048 10.3003H12.8083L11.9201 11.1404C11.7263 11.3008 11.5324 11.4123 11.2575 11.3949C10.9473 11.3809 10.6936 11.1613 10.5526 11.0428L7.76463 8.95465L4.1167 12.7719C3.72547 13.0961 3.14039 13.0473 2.81261 12.6568C2.48482 12.2699 2.53416 11.6912 2.92539 11.367L7.32406 5.98453C7.48972 5.84509 7.70119 5.77189 7.91971 5.77189"
        fill="#231F20"
      />
      <path
        d="M0.70139 16C0.317212 16 0 15.6897 0 15.3063V2.69373C0 2.31026 0.313687 2 0.70139 2C1.08909 2 1.40278 2.31026 1.40278 2.69373V14.616H17.3021C17.6863 14.616 18 14.9263 18 15.3063C18 15.6863 17.6863 16 17.3021 16H0.70139Z"
        fill="#231F20"
      />
    </svg>
  );
}
